
import Vue from 'vue'
import { VCheckbox } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcCheckbox',
  components: {
    VCheckbox,
  },
  props: {
    color: { type: String, default: 'primary' },
    required: { type: Boolean, default: false },
    errorMessage: { type: String, default: 'Required' },
    label: { type: String, default: '' },
    dense: { type: Boolean, default: false },
    check: { type: [Boolean, String], default: false },
    hint: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      checked: this.check,
      rules: [(v) => Boolean(v) || this.errorMessage],
      colorValue: this.color,
    }
  },
  watch: {
    check() {
      this.checked = this.formatCheck(this.check)
    },
  },
  created() {
    this.checked = this.formatCheck(this.check)
  },
  methods: {
    onMousedown() {
      this.readonlyHandler()
    },
    onMouseup() {
      if (this.readonly) {
        this.colorValue = this.color
      }
    },
    readonlyHandler() {
      this.readonly
        ? (this.colorValue = 'error')
        : (this.colorValue = this.color)
    },
    formatCheck(check) {
      const type = typeof check
      if (type == 'string') {
        switch (check) {
          case 'Y':
            return true
          default:
            return false
        }
      } else {
        return check
      }
    },
  },
})
